/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export interface SessionExpiryModalProps {
  open: boolean;
  graceSecondsRemaining: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function SessionExpiryModal({
  open,
  graceSecondsRemaining,
  onStayLoggedIn,
  onLogout,
}: SessionExpiryModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) onStayLoggedIn();
      }}
    >
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={(e) => {
          e.preventDefault();
        }}
        onEscapeKeyDown={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle>Session about to expire</DialogTitle>
          <DialogDescription>
            You have been inactive for a while. Do you want to stay logged in?
            {graceSecondsRemaining > 0 && (
              <span className="mt-2 block font-medium text-foreground">
                You will be logged out in {graceSecondsRemaining} second
                {graceSecondsRemaining !== 1 ? "s" : ""}.
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onLogout}>
            Log out
          </Button>
          <Button onClick={onStayLoggedIn}>Stay logged in</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
